<div class="dialog-container">
    <header class="dialog-header p-lr20 p-t20" >
        <div  class="flex-row-container">    
            <span *ngIf="mode==='edit'" class="flex-1 B font18">Edit {{roleDesc}}</span>
            <span *ngIf="mode==='add'" class="flex-1 B font18">Add Spouse</span>
            <mat-icon class="pointer" aria-hidden="false" (click)="closeDialog(false)">close</mat-icon>
        </div>    
    </header>
    <main class="dialog-content m-10" style="background-color: white;">        
        <form [formGroup]="form" class="p-l45 p-t20">
            <div class="flex-row-container p-tb15">
                <div class="column">
                    <span class="font16">Name</span>              
                </div>
                <div class="column">
                    <span *ngIf="clientname" class="font18">{{clientname | uppercase}}</span>   
                </div>
            </div>
            <div class="flex-row-container">
                <div class="column">
                    <span class="font16 m-t10 lh-100">Date Of Birth</span>              
                </div>
                <div class="column">
                    <mat-form-field appearance="fill" style="width: 200px">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput [matDatepicker]="dob"
                            [formControlName]="'dateOfBirth'"
                            (dateInput)="dobChangeEvent($event)" (dateChange)="dobChangeEvent($event)">
                        <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                        <mat-datepicker #dob></mat-datepicker>
                        <mat-hint align="end" style="color:var(--neutralSecondary)">Minimum required age: 18</mat-hint>
                    </mat-form-field> (Age: {{age}})             
                </div>
            </div>
            <div class="flex-row-container lh-40">
                <div class="column">
                    <span class="font16">Gender</span>              
                </div>
                <div class="column">                        
                    <mat-button-toggle-group class="" style="width:200px;" [formControlName]="'gender'">
                        <mat-button-toggle color="primary" class="font14" style="width:120px" value='M'><span class="">Male</span></mat-button-toggle>
                        <mat-button-toggle color="primary" class="font14" style="width:120px" value='F'><span class="m-r5">Female</span></mat-button-toggle>
                      </mat-button-toggle-group>
                </div>
            </div>
            <div class="flex-row-container m-t10">
                <div class="column">
                    <span class="font16 lh-75">State</span>              
                </div>
                <div class="column">   
                    <mat-form-field style="width: 200px">
                        <mat-label></mat-label>
                        <mat-select [formControlName]="'state'">
                        <mat-option *ngFor="let state of states" [value]="state.code">
                            {{state.value}}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="flex-row-container">
                <div class="column">
                    <span class="font16 lh-75">Employment Status</span>              
                </div>
                <div class="column">  
                    <mat-form-field style="width: 200px">
                        <mat-label></mat-label>
                        <mat-select [formControlName]="'empType'">
                        <mat-option *ngFor="let empType of empTypes" [value]="empType.code" (onSelectionChange)="selectEmpType($event, empType.code)">
                            {{empType.value}}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>                      
                </div>
            </div>
            <!-- <div class="flex-row-container p-tb15">
                <div class="column">
                    <span class="font16">Employment Income</span>              
                </div>
                <div class="column">
                    <span>Please add or edit employment/social security income on "Income" tab.</span>   
                </div>
            </div> -->
            <!-- <div class="flex-row-container">
                <div class="column">
                    <span class="font16 lh-75">Employment Income</span>              
                </div>
                <div class="column">     
                    <mat-form-field style="width: 200px">
                        <input matInput type="text" [formControlName]="'empIncome'" 
                        placeholder="" 
                        aria-label="Employment Income"                         
                        style="padding-left: 10px;"
                        class="ip-right-align p-r5"                 
                        />
                    </mat-form-field>                   
                </div>
            </div> -->
        </form>
    </main>
    <footer class="flex-col-end m-10">
        <mat-divider class="divider" style="width: 98%"></mat-divider>
        <div class="flex-row-container m-t15">
            <!-- <span class="m-r25 error align-self">{{validationMsg}}</span> -->
            <span class="m-t7">Please add or edit employment/social security income on "Income" tab.</span>   
            <button mat-button color="primary" (click)="closeDialog(false)">Cancel</button>
            <!-- <button *ngIf="mode==='edit' && role==='Secondary'" class="m-lr10" mat-raised-button color="primary" (click)="removeSpouse()">Remove Spouse</button> -->
            <button class="m-lr10" mat-raised-button [disabled]="!form.valid || age<18" color="primary" (click)="saveClient()">Save</button>
        </div>
    </footer>
  </div>